export var defaultProps = {
  style: {
    height: 200,
    width: 200
  },
  imageUrl: 'https://assets.airtel.in/static-assets/home-recast/images/recommendations-slide-1.png'
};